import { NodeModelBase } from './NodeModelBase';
export class RsNodeModel extends NodeModelBase {
    public Id: number;
    public ParentId: number;
    public Type: string;
    public Url: string;
    public Path: string;
    public Level: number;

    constructor(id: number, parentId: number, name: string, children: Array<NodeModelBase> = null) {
        super(name, children);
        this.Id = id;
        this.ParentId = parentId;
    }

    get icon() {
        if (this.Type == "Folder") {
            if (!this.Expanded) {
                return 'fas fa-folder-o';
            } else {
                return 'fas fa-folder-open-o';
            }
        } else if (this.Type == "Report") {
            return 'fas far fa-file-pdf';
        }
    }
}